<template>
  <div class="gma-page">
    <div class="operations">
      <a-input-search
        v-model:value="phoneQuery"
        placeholder="按手机号搜索"
        style="width: 220px; margin-right: 12px"
        allow-clear
        @search="loadUsers"
      />
      <a-button @click="loadUsers">刷新</a-button>
      <a-button type="primary" style="margin-left: 12px" @click="openGrant">添加权限</a-button>
    </div>

    <a-alert
      v-if="loadError"
      type="error"
      show-icon
      :message="loadError"
      style="margin-bottom: 12px"
    />

    <a-table
      :columns="columns"
      :data-source="users"
      :loading="loading"
      row-key="userId"
      :pagination="pagination"
      @change="onTableChange"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'phoneNum'">
          <span v-if="record.phoneNum">{{ record.phoneNum }}</span>
          <span v-else class="gma-muted">未绑定手机</span>
        </template>
        <template v-else-if="column.key === 'nickname'">
          <span v-if="record.nickname">{{ record.nickname }}</span>
          <span v-else class="gma-muted">—</span>
          <span v-if="record.nicknameFromFeishu" class="gma-tag-feishu">飞书</span>
        </template>
        <template v-else-if="column.key === 'isGigaManager'">
          <a-tag :color="record.isGigaManager ? 'green' : 'orange'">
            {{ record.isGigaManager ? '生效' : '未生效' }}
          </a-tag>
        </template>
        <template v-else-if="column.key === 'actions'">
          <a-button type="link" danger @click="confirmRevoke(record)">移除</a-button>
        </template>
      </template>
    </a-table>

    <a-modal
      v-model:visible="grantVisible"
      title="添加小程序员工权限"
      :confirm-loading="granting"
      ok-text="保存"
      @ok="submitGrant"
    >
      <a-form layout="vertical">
        <a-form-item label="手机号" required>
          <a-input
            v-model:value="grantForm.phoneNum"
            maxlength="11"
            placeholder="11 位手机号"
          />
        </a-form-item>
        <a-form-item label="备注姓名（可选）">
          <a-input v-model:value="grantForm.nickname" placeholder="仅在新用户时写入昵称" />
        </a-form-item>
        <div class="gma-hint">
          授予后可在小程序看到「内容采集」等员工功能。若用户尚未登录过小程序，也会先创建账号并挂上权限。
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import {
  getGigaManagerAccessUsers,
  grantGigaManagerAccess,
  revokeGigaManagerAccess,
} from '../http/api'

export default {
  name: 'GigaManagerAccess',
  data() {
    return {
      phoneQuery: '',
      users: [],
      loading: false,
      loadError: '',
      total: 0,
      page: 1,
      pageSize: 50,
      grantVisible: false,
      granting: false,
      grantForm: {
        phoneNum: '',
        nickname: '',
      },
      columns: [
        { title: '手机号', dataIndex: 'phoneNum', key: 'phoneNum' },
        { title: '昵称', dataIndex: 'nickname', key: 'nickname' },
        { title: '权限状态', key: 'isGigaManager', width: 120 },
        { title: '用户 ID', dataIndex: 'userId', key: 'userId', width: 100 },
        { title: '操作', key: 'actions', width: 100 },
      ],
    }
  },
  computed: {
    pagination() {
      return {
        current: this.page,
        pageSize: this.pageSize,
        total: this.total,
        showSizeChanger: false,
      }
    },
  },
  created() {
    this.loadUsers()
  },
  methods: {
    onTableChange(pagination) {
      this.page = pagination.current
      this.loadUsers()
    },
    loadUsers() {
      this.loading = true
      this.loadError = ''
      const offset = (this.page - 1) * this.pageSize
      getGigaManagerAccessUsers({
        phone: this.phoneQuery || undefined,
        limit: this.pageSize,
        offset,
      }).then((res) => {
        if (!res.success) {
          this.loadError = res.message || '加载失败'
          return
        }
        this.users = res.data.users || []
        this.total = res.data.total || 0
      }).catch((err) => {
        this.loadError = err.message || '加载失败'
      }).finally(() => {
        this.loading = false
      })
    },
    openGrant() {
      this.grantForm = { phoneNum: '', nickname: '' }
      this.grantVisible = true
    },
    submitGrant() {
      const phoneNum = String(this.grantForm.phoneNum || '').trim()
      if (!/^1\d{10}$/.test(phoneNum)) {
        this.$message.error('请输入 11 位手机号')
        return
      }
      this.granting = true
      grantGigaManagerAccess({
        phoneNum,
        nickname: this.grantForm.nickname || undefined,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.message || '添加失败')
          return
        }
        this.$message.success('已添加权限')
        this.grantVisible = false
        this.page = 1
        this.loadUsers()
      }).catch((err) => {
        this.$message.error(err.message || '添加失败')
      }).finally(() => {
        this.granting = false
      })
    },
    confirmRevoke(record) {
      Modal.confirm({
        title: '确定移除该手机号的小程序员工权限？',
        content: record.phoneNum,
        okText: '移除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => this.revokeUser(record),
      })
    },
    revokeUser(record) {
      return revokeGigaManagerAccess({
        phoneNum: record.phoneNum || undefined,
        userId: record.userId,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.message || '移除失败')
          return
        }
        this.$message.success('已移除权限')
        this.loadUsers()
      }).catch((err) => {
        this.$message.error(err.message || '移除失败')
      })
    },
  },
}
</script>

<style scoped>
.gma-page {
  padding: 0 4px;
}
.operations {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.gma-hint {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  line-height: 1.5;
}
.gma-muted {
  color: rgba(0, 0, 0, 0.35);
}
.gma-tag-feishu {
  margin-left: 6px;
  padding: 0 6px;
  font-size: 12px;
  color: #1677ff;
  background: #e6f4ff;
  border-radius: 4px;
}
</style>
